import type { Method } from 'lib/axios';
import { APICallV2Get, APICallV4 } from 'reactApp/api/APICall';
import { apiMigrateDomainFoldersV2ToV4 } from 'reactApp/appHelpers/featuresHelpers/features/apiMigrateDomainFoldersV2ToV4';

/** Запрос за доменными папками */
const method = 'domain/folders';

export class DomainFoldersApiV2Call extends APICallV2Get {
    _method = method;
}

export class DomainFoldersApiV4Call extends APICallV4 {
    _method = method;
    _type: Method = 'get';
}

export const getDomainFoldersApiCall = () => {
    if (apiMigrateDomainFoldersV2ToV4) {
        return new DomainFoldersApiV4Call();
    }

    return new DomainFoldersApiV2Call();
};
